import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import iconSave from "../../assets/Profile/IconSave.png";
import { useAuth } from "../../context/AuthContext";
import { CustomInput } from "../../components/CustomInput";
import Swal from "sweetalert2";

const EnterpriseInfo = () => {
    const [formHasChanges, setFormHasChanges] = useState(false);
    const {
        enterprise,
        updateProfileEnterprise,
        user,
    } = useAuth();

    const {
        register,
        handleSubmit,
        formState: { errors, isDirty, dirtyFields },
        watch,
        reset
    } = useForm({
        defaultValues: {
            name: enterprise.enterprise.name || "",
            email: enterprise.enterprise.email || "",
            rfc: enterprise.enterprise.rfc || "",
            address: enterprise.enterprise.address || "",
            phone: enterprise.enterprise.phone || "",
        }
    });

    const watchAllFields = watch();
    
    useEffect(() => {
        setFormHasChanges(isDirty);
    }, [watchAllFields, isDirty]);

    const onSubmit = async (data) => {
        try {
            await updateProfileEnterprise(user.id, data);
            
            reset({
                name: data.name,
                email: data.email,
                rfc: data.rfc,
                address: data.address,
                phone: data.phone,
            });
            
            setFormHasChanges(false);
            
            Swal.fire({
                icon: "success",
                title: "Éxito",
                text: "Información actualizada correctamente",
            });
        } catch (error) {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Hubo un problema al actualizar la información",
            });
        }
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className="flex flex-col">
                {Object.keys(errors).length > 0 && (
                    <div className="flex flex-col gap w-full px-4 py-2 bg-red-100 border border-red-400 text-red-700 rounded">
                        {errors.name && (
                            <span className="text-red-600 text-sm">
                                {errors.name.message}
                            </span>
                        )}
                        {errors.address && (
                            <span className="text-red-600 text-sm">
                                {errors.address.message}
                            </span>
                        )}
                        {errors.email && (
                            <span className="text-red-600 text-sm">
                                {errors.email.message}
                            </span>
                        )}
                        {errors.rfc && (
                            <span className="text-red-600 text-sm">
                                {errors.rfc.message}
                            </span>
                        )}
                        {errors.phone && (
                            <span className="text-red-600 text-sm">
                                {errors.phone.message}
                            </span>
                        )}
                    </div>
                )}
                <span className="font-medium">
                    En esta sección llenarás los datos generales de tu empresa.
                </span>
            </div>
            <div className="grid grid-cols-2 gap-8 ">
                <div className="flex flex-col gap-5">
                    <div className="flex flex-col gap-1">
                        <p className="text-[12px]">Nombre de la empresa</p>
                        <CustomInput
                            bg="bg-transparent"
                            type="text"
                            id="name"
                            name="name"
                            placeholder="Desarrollos Inmobiliarios Mex, S.A. de C.V."
                            border="border-nemu-plata"
                            {...register("name", { required: "El nombre es obligatorio" })}
                        />
                    </div>
                    <div className="flex flex-col gap-1">
                        <p className="text-[12px]">Correo electrónico:</p>
                        <CustomInput
                            bg="bg-transparent"
                            type="email"
                            id="email"
                            name="email"
                            placeholder="contacto@desarrollosmex.com"
                            border="border-nemu-plata"
                            {...register("email", { 
                                required: "El correo es obligatorio",
                                pattern: {
                                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                    message: "Correo electrónico inválido"
                                }
                            })}
                        />
                    </div>
                    {/* <div className="flex flex-col gap-1">
                        <p className="text-[12px]">Total de proyectos entregados</p>
                        <CustomInput
                            bg="bg-transparent"
                            type="number"
                            min="0"
                            id="rfc"
                            name="rfc"
                            placeholder="12"
                            border="border-nemu-plata"
                            {...register("rfc", { required: false })}
                        />
                    </div> */}
                </div>
                <div className="flex flex-col gap-5">
                    <div className="flex flex-col gap-1">
                        <p className="text-[12px]">Domicilio</p>
                        <CustomInput
                            bg="bg-transparent"
                            type="text"
                            id="direction"
                            name="direction"
                            placeholder="Av. Reforma 123, Colonia Juárez, Alcaldía Cuauhtémoc, Ciudad de México, C.P. 06600"
                            border="border-nemu-plata"
                            {...register("address", { required: "El domicilio es obligatorio" })}
                        />
                    </div>
                    <div className="flex flex-col gap-1">
                        <p className="text-[12px]">Teléfono</p>
                        <CustomInput
                            bg="bg-transparent"
                            type="text"
                            id="number"
                            name="number"
                            placeholder="+52 (55) 1234-5678"
                            border="border-nemu-plata"
                            {...register("phone", { required: "El teléfono es obligatorio" })}
                        />
                    </div>
                </div>
            </div>

            <hr className="border-t-1 border-nemu-plata mt-6 mb-4" />
            <button 
                type="submit"
                className={`flex w-max h-[100%] gap-[8px] justify-center rounded-[4px] px-[16px] py-[8px] ${
                    formHasChanges 
                        ? "bg-nemu-azul cursor-pointer" 
                        : "bg-nemu-plata"
                }`}
                disabled={!formHasChanges}
            >
                <img src={iconSave} alt="Save Icon" />
                <p className="text-white">Guardar cambios</p>
            </button>
        </form>
    );
}

export { EnterpriseInfo };